import { render, staticRenderFns } from "./PriceCard.vue?vue&type=template&id=3f524566&scoped=true"
import script from "./PriceCard.vue?vue&type=script&lang=js"
export * from "./PriceCard.vue?vue&type=script&lang=js"
import style0 from "./PriceCard.vue?vue&type=style&index=0&id=3f524566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f524566",
  null
  
)

export default component.exports